import { Grid } from "@mui/material";
import { useEffect, useState } from "react";

import Select from "react-select";
import { getSchoolsClave } from "../../Utils/Funciones/getSchools";
import { consultarCatalogo } from "../../Utils/Funciones/consultarCatalogo";

function ReporteDictamenesForm({ form, setForm = () => {}, campusOptions }) {
  const [schoolOtions, setSchoolOtions] = useState([]);
  const [directionOptions, setDirectionOptions] = useState([]);
  const handleChangeForm = (e, key) => {
    setForm((prev) => ({
      ...prev,
      [key]: e,
    }));
  };

  useEffect(() => {
    getSchoolsClave().then((date) => {
      setSchoolOtions(date);
    });
    consultarCatalogo(7, () => {}).then((data) => {
      setDirectionOptions(data);
    });
  }, []);

  return (
    <Grid container xs={14} sm={10} justifyContent="space-between" spacing={2}>
      <Grid item xs={6}>
        <Grid container direction="row" alignItems="center">
          <Grid item style={{ marginRight: 10, width: 100 }}>
            <label>Campus (*):</label>
          </Grid>
          <Grid item xs={8} lg={7} md={5}>
            <Select
              className="select-modal-container"
              classNamePrefix="select-modal"
              options={campusOptions}
              value={form?.campus}
              onChange={(e) => handleChangeForm(e, "campus")}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container direction="row" alignItems="center">
          <Grid item style={{ marginRight: 10, width: 100 }}>
            <label>Ciclo (*):</label>
          </Grid>
          <Grid item xs={8} lg={7} md={5}>
            <input
              className="filter-input"
              value={form?.ciclo}
              onChange={(e) => handleChangeForm(e.target.value, "ciclo")}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container direction="row" alignItems="center">
          <Grid item style={{ marginRight: 10, width: 100 }}>
            <label>Escuela:</label>
          </Grid>
          <Grid item xs={8} lg={7} md={5}>
            <Select
              className="select-modal-container"
              classNamePrefix="select-modal"
              options={schoolOtions}
              value={form?.escuela}
              onChange={(e) => handleChangeForm(e, "escuela")}
              isClearable={true}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container direction="row" alignItems="center">
          <Grid item style={{ marginRight: 10, width: 100 }}>
            <label>Dirección:</label>
          </Grid>
          <Grid item xs={8} lg={7} md={5}>
            <Select
              className="select-modal-container"
              classNamePrefix="select-modal"
              options={directionOptions}
              value={form?.direccion}
              onChange={(e) => handleChangeForm(e, "direccion")}
              isClearable={true}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container direction="row" alignItems="center">
          <Grid item style={{ marginRight: 10, width: 100 }}>
            <label>Fecha Inicio:</label>
          </Grid>
          <Grid item xs={8} lg={7} md={5}>
            <input
              className="filter-input"
              label="Seleccionar fecha"
              type="date"
              value={form.fechaInicio}
              onChange={(e) => handleChangeForm(e.target.value, "fechaInicio")}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container direction="row" alignItems="center">
          <Grid item style={{ marginRight: 10, width: 100 }}>
            <label>Fecha Fin:</label>
          </Grid>
          <Grid item xs={8} lg={7} md={5}>
            <input
              className="filter-input"
              label="Seleccionar fecha"
              type="date"
              disabled={!form.fechaInicio}
              value={form.fechaFin}
              min={form.fechaInicio}
              onChange={(e) => handleChangeForm(e.target.value, "fechaFin")}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ReporteDictamenesForm;
